<template>
    <NuxtLink :to="`${url}${item.id}`" class="card-neighborhood">
        <!-- <pre>{{ item.fields.Name }}</pre> -->
        <div class="image-wrapper" :class="{ 'is-square': imageStyle === 'square' }">
            <GlobalNeighborhoodMapImage v-if="imageStyle === 'square'" :name="item.fields.Name || ''" />
            <img v-else :src="`/img/pages/neighborhoods/map-${neighborhoodSnakeCase(item.fields.Name)}.jpg`" alt="Neighborhood map image" />
            <p class="red-tag">{{ siteQuantity }} Sites</p>
        </div>
        <h3 class="headline-3">{{ item.fields.Name }}</h3>
    </NuxtLink>
</template>

<script setup>
    import { neighborhoodSnakeCase } from '~/composables/helpers/neighborhoodSnakeCase.js';
    const props = defineProps({
        item: {
            type: Object,
            required: true,
        },
        imageStyle: {
            type: String,
            required: false,
            default: 'landscape',
        },
    });
    const { item } = toRefs(props);

    // `Confirmed Sites Count` is 0 on every neighborhood in Airtable, so this
    // printed "0 Sites" on every card while the pages behind them listed sites
    // fine (Asana O2-40). Count what the page will actually show instead.
    const { sitesData } = storeToRefs(useSitesStore());
    const siteQuantity = computed(() => neighborhoodSiteRecords(item.value, sitesData.value).length);

    const route = useRoute();
    const url = computed(() => {
        if (route.path.includes('archive')) return '/archive/2023/neighborhoods/';
        else return '/neighborhoods/';
    });
</script>

<style lang="scss" scoped>
    .card-neighborhood {
        pointer-events: auto;

        a {
            display: block;
        }
        .image-wrapper {
            height: 0;
            padding-top: 47.5%;
            width: 100%;
            position: relative;
            margin-bottom: 10px;

            @media (min-width: $tablet) {
                width: 50%;
                padding-top: 28%;
            }

            // The square artwork this card swaps to for imageStyle="square"
            // needs a square box. This used to live in
            // Blocks/neighborhoods-carousel.vue as `.card-neighborhood
            // .image-wrapper`, which is *weaker* than the scoped rule above it
            // was trying to override — so which one won came down to stylesheet
            // order, and dev and production disagreed: dev rendered 248x248,
            // production 124x70. Owning it here, keyed off the same prop that
            // picks the artwork, makes it deterministic.
            &.is-square {
                padding-top: 100%;

                @media (min-width: $tablet) {
                    width: 100%;
                    padding-top: 100%;
                }
            }

            // :deep because the square variant's image is inside
            // GlobalNeighborhoodMapImage now — a scoped `img` selector stops at
            // the child's root <picture> and never reaches it.
            img, :deep(img) {
                width: 100%;
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
                object-fit: cover;
                object-position: center;
            }

            .red-tag {
                position: absolute;
                bottom: 10px;
                left: 10px;
                background-color: $red;
                z-index: 2;
                font-size: 12px;
                color: $white;
                font-weight: 800;
                height: 26px;
                padding: 8px 10px 0;
            }
        }
    }
</style>
